import { Button, Modal, Text, VStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Modal as NativeModal } from 'native-base';
import React from 'react';

interface ReportGeneratorRetryLimitModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ReportGeneratorRetryLimitModal: React.FC<ReportGeneratorRetryLimitModalProps> = ({
  isOpen,
  onClose,
}) => (
  <Modal isOpen={isOpen} onClose={onClose} testId="report-generator-retry-limit-modal">
    <NativeModal.Content
      alignItems="center"
      w="full"
      maxW={{ base: 'full', lg: '420px' }}
      marginBottom={{ base: 0, lg: 'none' }}
      marginTop={{ base: 'auto', lg: 0 }}
      borderRadius={BoxBorder.heavy}
      bg="neutral.white">
      <VStack w="full" px="inline.xxs" py="inline.xs" space="stack.xxxs">
        <Text variant="semibold" fontSize="lg" color="neutral.darkest" textAlign="center">
          Limite de tentativas
        </Text>
        <Text fontSize="md" color="neutral.dark" textAlign="center">
          Você atingiu o limite de tentativas de reprocessar este relatório.
        </Text>
        <Button
          testID="report-generator-retry-limit-confirm"
          onPress={onClose}
          variant="primary"
          alignSelf="center"
          mt="stack.nano">
          Entendi
        </Button>
      </VStack>
    </NativeModal.Content>
  </Modal>
);
